
export type HandleWebhook200 = {
  message?: string;
  processedAt?: string;
  success?: boolean;
};
